import React, { ReactNode } from 'react';
import { Typography, Chip } from '@mui/material';
import dayjs from 'dayjs';
import { formatNumber } from './formatters';

/**
 * Creates a renderer for date columns
 */
export const createDateRenderer = (field: string) => {
  return (_column: any, row: any): ReactNode => (
    <Typography variant="body2">
      {row[field] ? dayjs(row[field]).format('DD/MM/YYYY') : '-'}
    </Typography>
  );
};

/**
 * Creates a renderer for company name column
 */
export const createCompanyNameRenderer = () => {
  return (_column: any, row: any): ReactNode => (
    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>
      {row?.name || row?.companyName || 'Company'}
    </Typography>
  );
};

/**
 * Creates a renderer for status column with chip
 */
export const createStatusRenderer = () => {
  return (_column: any, row: any): ReactNode => (
    <Chip
      size="small"
      label={row.status || '-'}
      color={row.status === 'COMPLETED' ? 'success' : 'info'}
      sx={{ py: 1 }}
    />
  );
};

/**
 * Creates a renderer for description column with HTML support
 */
export const createDescriptionRenderer = () => {
  return (_column: any, row: any): ReactNode => (
    <Typography
      variant="body2"
      sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
      dangerouslySetInnerHTML={{ __html: row.description || '-' }}
    />
  );
};

/**
 * Creates a renderer for numeric columns with formatting
 */
export const createNumericRenderer = (field: string, fontWeight: number = 600) => {
  return (_column: any, row: any): ReactNode => (
    <Typography variant="body2" sx={{ fontWeight, color: 'text.primary' }}>
      {formatNumber(Number(row[field] ?? 0))}
    </Typography>
  );
};

/**
 * Creates a renderer for managedBy column (handles arrays)
 */
export const createManagedByRenderer = () => {
  return (_column: any, row: any): ReactNode => (
    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
      {Array.isArray(row?.managedBy) ? row.managedBy.join(', ') : row?.managedBy ?? '—'}
    </Typography>
  );
};

